import { render, staticRenderFns } from "./goodsType.vue?vue&type=template&id=f5f919ee"
import script from "./goodsType.vue?vue&type=script&lang=ts"
export * from "./goodsType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports